<div class="compliance-missed-guidelines__header">{{ (complianceOnly ? "results.NO_SCORE_COMPLIANCE_ONLY" : "results.POSSIBLE_COMPLIANCE_ISSUES") | transloco }}</div>
<div class="compliance-missed-guidelines__body">
  <div class="compliance-missed-guidelines__title">{{ (complianceOnly ? "results.WHY_OUT_OF_COMPLIANCE_COMPLIANCE_ONLY" : "results.WHY_OUT_OF_COMPLIANCE") | transloco }}</div>
  <div class="compliance-missed-guidelines__subtitle">{{ "results.REVIEW_MISSED_GUIDELINES" | transloco }}</div>
  <ul class="compliance-missed-guidelines__list">
    @for (fact of missedFacts; track $index) {
      <li class="compliance-missed-guidelines__item">
        <img class="compliance-missed-guidelines__icon" src="assets/icons/exclamation-red.svg" [alt]="'results.X_ICON_ALT' | transloco" />
        <div>
          {{ fact.factText || fact.messageText }}
          @if (showSampleQuote && fact.sampleQuote; as quote) {
            @let parts = quoteParts(quote);
            <p class="compliance-missed-guidelines__quote">
              {{ "results.EXAMPLE_FROM_CONVERSATION" | transloco }}
              <q>{{ parts.before }}<strong>{{ parts.flagged }}</strong>{{ parts.after }}</q>
            </p>
          }
        </div>
      </li>
    }
  </ul>
</div>
